import { render, staticRenderFns } from "./fot.vue?vue&type=template&id=d3f4bca4&scoped=true"
import script from "./fot.vue?vue&type=script&lang=js"
export * from "./fot.vue?vue&type=script&lang=js"
import style0 from "./fot.vue?vue&type=style&index=0&id=d3f4bca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f4bca4",
  null
  
)

export default component.exports